import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import classNames from "classnames";

const LanguageSwitch = ({ closeMenu }) => {
  const i18n = useSelector((reduxStore) => reduxStore.i18n);
  const mainMenuOpen = useSelector(
    (reduxStore) => reduxStore.appStore.mainMenuOpen
  );
  const microSite = useSelector((reduxStore) => reduxStore.appStore.microSite);

  return (
    <nav
      className="language-switch"
      aria-label="Language selector"
    >
      {i18n.translations?.length > 1 &&
        <>
          {i18n.translations.map((translation) => (
            <a
              key={translation.language.id}
              href={translation.url.path}
              onClick={closeMenu ? closeMenu : null}
              tabIndex={microSite ? `0` : `${mainMenuOpen ? '0' : '-1'}`}
              className={classNames({
                "body-m": true,
                "active make-headline-light": i18n.currentLanguage === translation.language.id,
                //"not-translated": !translation.path,
              })}
              aria-current={i18n.currentLanguage === translation.language.id ? "true" : undefined}
            >
              {translation.language.id.toUpperCase()}
            </a>
          ))}
        </>
      }
    </nav>
  );
};

LanguageSwitch.propTypes = {
  closeMenu: PropTypes.func,
};

export default LanguageSwitch;
